import React, { useState } from 'react';
import './index.css';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
import Students from './components/Students';
import Teachers from './components/Teachers';
import Scan from './components/Scan';
import Events from './components/Events';
import MapView from './components/MapView';
import Unknowns from './components/Unknowns';
import ApiKeys from './components/ApiKeys';
import GpsWatches from './components/GpsWatches';
import CameraAgents from './components/CameraAgents';

export default function App() {
  const [tab, setTab] = useState('dashboard');
  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--slate-100)' }}>
      <Sidebar tab={tab} setTab={setTab} />
      <main style={{ flex: 1, minWidth: 0, overflowY: 'auto' }}>
        {tab === 'dashboard' && <Dashboard />}
        {tab === 'students'  && <Students />}
        {tab === 'teachers'  && <Teachers />}
        {tab === 'scan'      && <Scan />}
        {tab === 'events'    && <Events />}
        {tab === 'cameras'   && <CameraAgents />}
        {tab === 'gps'       && <GpsWatches />}
        {tab === 'map'       && <MapView />}
        {tab === 'unknowns'  && <Unknowns />}
        {tab === 'apikeys'   && <ApiKeys />}
      </main>
    </div>
  );
}
